<ng-template #sistemi let-data="data" let-header="header">
  <ng-container *ngIf="data.scommesse">
    <div *ngFor="let detail of data.scommesse" class="ticket-items">
      <div *ngIf="detail.fissa === '1'" class="sys-fissa">
        <span>FISSA</span>
      </div>
      <div>
        <div class="ml-1">
          <div *ngIf="detail.scommessa !== '13'" class="div-race-number">
            <div>{{'RACE.RACE' | translate}}</div>
            <div *ngIf="header && header.antepost === '1'">{{detail.descrizione}}</div>
            <div *ngIf="header && header.antepost === '1'">{{'MENU.ANTEPOST' | translate | uppercase}}</div>
            <div class="div-number-size" *ngIf="header && header.antepost === '0'">{{detail.number}}</div>
          </div>
          <div *ngIf="detail.scommessa === '13'" class="div-race-number">
            <div>Vittoria</div>
            <div class="div-number-size">U/O</div>
          </div>
        </div>
        <div class="ml-1 mr-1 div-tshirt" *ngIf="detail.image">
          <img #image class="img-tshirt" alt="image tshirt" [src]="this.imgUrl + detail.image" (error)="image.hidden = true"
               (load)="image.hidden = false" [hidden]="image.hidden">
        </div>
        <div class="p-1 div-tdescr">
          <div *ngIf="detail.scommessa !== '13'">
            <span *ngIf="detail.rdate" class="text-capitalize text-ellipsis" title="{{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}} - {{detail.course}}">
                {{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}}
                <br/>
                {{detail.course}}
            </span>
          </div>
          <div *ngIf="detail.scommessa === '13'">
                <span *ngIf="detail.rdate" class="text-capitalize text-ellipsis"
                      title="{{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}} - {{detail.course}}">
                  {{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}}
                </span>
            <span>{{detail.course}}</span>
            <div *ngIf="detail.scommessa === '13'">
              <small>{{'RACE.RACES' | translate}} ({{detail.extra2}})</small>
            </div>
          </div>

          <div class="mt-1" *ngIf="detail.info_agg_desc && detail.scommessa !== '13' && excludeViewEsito(detail.scommessa)">
            <span>{{detail.info_agg_desc}}</span>
          </div>
            <div class="mt-1" *ngIf="detail.info_agg_desc && (detail.scommessa === '14' || detail.scommessa === '16' || detail.scommessa === '18' || detail.scommessa === '22' || detail.scommessa === '23' || detail.scommessa === '24')">
                <span>
<!--                    {{'RACE.HORSE' | translate}}: #{{detail.info_agg | infoAggBet: detail.scommessa: true}}-->
                    <span *ngIf="detail.scommessa !== '16' && detail.scommessa !== '18'">{{detail.info_agg_desc}}</span>
                    <span *ngIf="detail.scommessa === '22' || detail.scommessa === '23' || detail.scommessa === '24'"> {{'RACE.NOTPLACE_INFO' | translate }}</span>
                    <span *ngIf="detail.scommessa === '16' || detail.scommessa === '18'">{{detail.info_agg_desc.split('-')[0]}} {{('RACE.' + betType[detail.scommessa] + 'info_agg' | uppercase) | translate: {lenghts: detail.info_agg | infoAggBet: detail.scommessa, dispersion: detail.info_agg | infoAggBet: detail.scommessa} }}</span>
                </span>
            </div>
          <div class="mt-1" *ngIf="detail.scommessa === '13'">
            <span>{{'RACE.UNDER OVER' | translate}} {{'GENERAL.WINS' | translate}} {{(detail.info_agg | hexToDecimal)/100 | number : '1.2-2'}}</span>
          </div>

          <div class="mt-1" *ngIf="!detail.info_agg_desc && detail.scommessa !== '12'">
            <strong>{{'RACE.HORSE' | translate}}</strong>: &#x00023;{{detail.esito}} {{detail.cavallo}}
          </div>
          <div class="mt-1" *ngIf="!detail.info_agg_desc && detail.scommessa === '12'">
            <strong *ngIf="detail.esito === '1'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.EVEN' | translate}}</strong>
            <strong *ngIf="detail.esito === '2'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.ODD' | translate}}</strong>
          </div>
          <div class="mt-1" *ngIf="detail.scommessa !== '13'">
                <span class="mr-1"><strong>{{'TICKETS.BET' | translate}}:</strong>
                  {{('RACE.' + betType[detail.scommessa] | uppercase) | translate}}
                </span>
          </div>
          <div class="mt-1" *ngIf="detail.scommessa === '13'">
                <span class="mr-1"><strong>{{'TICKETS.BET' | translate}}:</strong>
                  {{('RACE.UNDER OVER') | translate}}
                </span>
          </div>
          <div class="mt-1" *ngIf="detail.info_agg_desc && detail.scommessa !== '13' && excludeViewEsito(detail.scommessa)">
            <strong>{{'RACE.OUTCOME' | translate}}</strong>: {{detail.esito}} ({{numberHorse(detail.info_agg,detail.esito)}} - {{detail.info_agg_desc.split(' VS ')[detail.esito-1]}})
          </div>
          <div class="mt-1" *ngIf="detail.info_agg_desc && detail.scommessa === '13'">
            <strong *ngIf="detail.esito === '1'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.UNDER' | translate}}</strong>
            <strong *ngIf="detail.esito === '2'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.OVER' | translate}}</strong>
          </div>
        </div>
        <div class="col-quota">
          <small class="mb-1">{{'TICKETS.ODD' | translate}}</small>
          <div>
            <strong class="p-2 quota" [ngClass]="{
                'text-danger': detail.stato === '0',
                'text-success': detail.stato === '1',
                '': detail.stato === '2',
                'text-warning': detail.stato === '3'}">
              <span [ngClass]="{'quota_old' : detail.quota_rit && detail.quota_rit !== '0' && detail.quota_rit !== detail.quota}">{{detail.quota/100 | number : '1.2-2'}}</span>
              <span *ngIf="detail.quota_rit !== '0' && detail.quota_rit !== detail.quota">{{detail.quota_rit/100 | number : '1.2-2'}}</span>
            </strong>
          </div>
        </div>
        <div class="col-risultato" *ngIf="detail.risultato && detail.risultato !== ''">
          <small class="mb-1">{{'TICKETS.RESULT' | translate}}</small>
          <div *ngIf="detail.scommessa !== '12' && excludeViewEsito(detail.scommessa)">
            <strong class="p-2 risultato">{{detail.risultato}}</strong>
          </div>
            <div *ngIf="(detail.scommessa === '22' || detail.scommessa === '23' || detail.scommessa === '24')">
                <strong class="p-2 risultato">{{detail.risultato}}</strong>
            </div>
          <div *ngIf="detail.scommessa === '12'">
            <strong class="p-2 risultato" *ngIf="detail.risultato === '1'">{{'GENERAL.EVEN' | translate}}</strong>
            <strong class="p-2 risultato" *ngIf="detail.risultato === '2'">{{'GENERAL.ODD' | translate}}</strong>
          </div>
          <div *ngIf="detail.scommessa === '13'">
            <strong class="p-2 risultato" *ngIf="detail.risultato === '1'">{{'RACE.UNDER' | translate}}</strong>
            <strong class="p-2 risultato" *ngIf="detail.risultato === '2'">{{'RACE.OVER' | translate}}</strong>
          </div>
          <div *ngIf="(detail.scommessa === '14' || detail.scommessa === '16' || detail.scommessa === '18')">
            <strong class="p-2 risultato" *ngIf="detail.risultato === '1'">{{'RACE.WINNER' | translate}}</strong>
            <strong class="p-2 risultato" *ngIf="detail.risultato === '2'">{{'TICKETS.LOSER' | translate}}</strong>
          </div>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>

<div *ngIf="data" id="frame-height" class="position-relative" #ticketFrame [ngClass]="partnerIdentify(data.cID)">
  <div id="sisal-ticket" [ngClass]="{'div-modal' : data.modal}" *ngIf="environment.sisalCID.includes(data.cID) else defalut">
    <div class="ticket-details-top p-3" *ngIf="data.modal">
      <span *ngIf="data.header.gioco !== 'QF'" matBadge="T"
            class="tot-circle pr-2"><strong>DETTAGLIO BIGLIETTO IPPICA</strong>
      </span>
      <span *ngIf="data.header.gioco === 'QF'"><strong>DETTAGLIO BIGLIETTO IPPICA</strong></span>
      <mat-icon (click)="this.dialogWindow.closeAll()" class="ticket-details-close-button" *ngIf="isDialog">close
      </mat-icon>
    </div>
    <div class="ticket-sisal-top-date">
      <div class="text-right betsliptype">
        {{data.header.gioco !== 'QF' ? (data.header.data_ora_vendita | date : 'dd/MM/yyyy - H:mm:ss':'':translateService.currentLang) : (data.header.data_ora_vendita + 'Z' | date : 'dd/MM/yyyy - H:mm:ss':'':translateService.currentLang)}}
      </div>
    </div>
    <div class="ticket-details-content">
      <div class="ticket-items ticket-items-padding" *ngIf="data.header.descrizione">
        <div class="ticket-info-pal">
          <mat-icon class="mr-1" svgIcon="{{data.header.tipologia | uppercase}}"></mat-icon> <span *ngIf="data.header.palinsesto">{{data.header.palinsesto}}</span> <span *ngIf="data.header.avvenimento"> - {{data.header.avvenimento}}</span>
        </div>
        <div>
          <div class="div-race-number">
            <div class="text-capitalize mb-2">{{data.header.gioco !== 'QF' ? (data.header.data_avvenimento | date : 'EEE d':'':this.translateService.currentLang) : (data.header.data_avvenimento + 'Z' | date : 'EEE d':'':this.translateService.currentLang)}}</div>
            <div>{{data.header.gioco !== 'QF' ? (data.header.data_avvenimento | date : 'H:mm':'':this.translateService.currentLang) : (data.header.data_avvenimento + 'Z' | date : 'H:mm':'':this.translateService.currentLang)}}</div>
          </div>

          <div class="p-1 mw-100 flex-grow-1">
            <div class="mt-1">
              <span class="text-capitalize text-ellipsis" style="font-size: 1.25em; font-weight: 900;" title="{{data.header.descrizione}}">{{data.header.descrizione}}</span>
            </div>
          </div>
        </div>
      </div>
      <ng-container *ngIf="data.dettaglio">
        <div class="ticket-inner-items">
        <div *ngFor="let detail of data.dettaglio" class="ticket-items">
        <div class="ticket-info-pal ticket-items-padding" *ngIf="data.header.gioco === 'QF'">
          <mat-icon class="mr-1" svgIcon="{{detail.tipologia | uppercase}}"></mat-icon>
          <span *ngIf="detail.palinsesto">{{data.header.palinsesto}}</span> <span *ngIf="detail.avvenimento"> - {{data.header.avvenimento}}</span>
          <span *ngIf="(!detail.palinsesto || !detail.avvenimento) && detail.race">{{detail.race}}</span>
        </div>
        <div *ngIf="data.header.gioco === 'QF'" class="ticket-items-padding">
            <div>
              <div class="div-race-number">
                <div class="text-capitalize mb-2">{{detail.rdate + 'Z' | date : 'EEE d':'':this.translateService.currentLang}}</div>
                <div>{{detail.rdate + 'Z' | date : 'H:mm':'':this.translateService.currentLang}}</div>
              </div>
            </div>
            <div class="ml-1 mr-1 div-tshirt">
              <img #image class="img-tshirt" alt="image tshirt" [src]="this.imgUrl + detail.image"  (error)="image.hidden = true"
                   (load)="image.hidden = false" [hidden]="image.hidden">
            </div>
            <div class="p-1">
            <div>
              <span *ngIf="detail.rdate" class="text-capitalize text-ellipsis" style="font-size: 1.25em; font-weight: 900;"
                    title="{{detail.descrizione | numberrace:'desc'}}">
                <span>{{detail.descrizione | numberrace:'desc'}}</span>
                <div *ngIf="detail.scommessa === '13'">
                  <small>{{'RACE.RACES' | translate}} ({{detail.extra2}})</small>
                </div>
                <ng-container *ngIf="detail.scommessa !== '13'">
                  <span *ngIf="data.header.antepost === '1'">&ensp;ANTEPOST</span>
                  <span *ngIf="data.header.antepost === '0'">{{'RACE.RACE' | translate}} {{detail.descrizione | numberrace:'num'}}</span>
                </ng-container>
              </span>
              <div class="mt-1" *ngIf="detail.info_agg_desc && detail.scommessa !== '13'">
                <span>{{detail.info_agg_desc}}</span>
              </div>
              <div class="mt-1" *ngIf="detail.scommessa === '13'">
                <span>{{'RACE.UNDER OVER' | translate}} {{'GENERAL.WINS' | translate}} {{(detail.info_agg | hexToDecimal)/100 | number : '1.2-2'}}</span>
              </div>
            </div>
            <div class="mt-1" *ngIf="!(data.dettaglio[0].sistema)">
              <span class="mr-1 ticket-des-scommessa">
                <span *ngIf="detail.scommessa !== '13'">{{('RACE.' + detail.des_scommessa | uppercase) | translate}}:&ensp;</span>
                <span *ngIf="detail.scommessa === '13'">{{('RACE.UNDER OVER') | translate}}:&ensp;</span>
                  <span *ngIf="!(data.dettaglio[0].sistema)">
                    <strong *ngIf="!detail.info_agg_desc && detail.scommessa !== '12'">{{detail.esito}} {{detail.cavallo}}</strong>
                    <strong *ngIf="detail.scommessa === '12'">
                      <span *ngIf="detail.esito === '1'">{{'GENERAL.EVEN' | translate}}</span>
                      <span *ngIf="detail.esito === '2'">{{'GENERAL.ODD' | translate}}</span>
                    </strong>
                    <strong *ngIf="detail.scommessa === '13'">
                      <span *ngIf="detail.esito === '1'">{{'RACE.UNDER' | translate}}</span>
                      <span *ngIf="detail.esito === '2'">{{'RACE.OVER' | translate}}</span>
                    </strong>
                    <strong *ngIf="detail.info_agg_desc && detail.scommessa !== '13'">
                      {{'RACE.OUTCOME' | translate}}: {{detail.esito}} ({{numberHorse(detail.info_agg,detail.esito)}} {{detail.info_agg_desc.split(' VS ')[detail.esito-1]}})
                    </strong>
                    <strong class="" >
                      (<span [ngClass]="{'quota_old' : detail.quota_rit && detail.quota_rit !== '0' && detail.quota_rit !== detail.quota}">{{detail.quota/100 | number : '1.2-2'}}</span>
                      <span *ngIf="detail.quota_rit && detail.quota_rit !== detail.quota">{{detail.quota_rit/100 | number : '1.2-2'}}</span>)
                    </strong>
                  </span>
              </span>
            </div>
            <div class="mt-1" *ngIf="(data.dettaglio[0].sistema)">
              <span class="mr-1"><strong>{{'TICKETS.BET' | translate}}:</strong>
                {{('RACE.' + detail.des_scommessa | uppercase) | translate}}</span>
            </div>
            <div *ngIf="(data.dettaglio[0].sistema)">
              <strong>{{'TICKETS.UNIT COST' | translate}}: </strong>
              <span>{{detail.costo_unitario/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
            </div>
          </div>
        </div>
        <div *ngIf="data.header.gioco !== 'QF'" class="d-flex ticket-items-padding justify-content-center">
          <div class="ticket-items-padding">
            {{detail.des_scommessa}} {{'TOTESYSTEM.WITH_SYSTEM' | translate}} {{detail.sigla_sys}} ({{detail.map}})
          </div>
          <div>
            {{detail.importo/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
          </div>
        </div>
        <div *ngIf="data.header.gioco === 'QF'">
          <span class="text-center mb-1 w-100 ticket-result">
            {{'TICKETS.RESULT' | translate}}:
            <strong class="p-2 risultato">
              <span *ngIf="detail.scommessa === '12'">
                <span *ngIf="detail.risultato === '1'">{{'GENERAL.EVEN' | translate}}</span>
                <span *ngIf="detail.risultato === '2'">{{'GENERAL.ODD' | translate}}</span>
              </span>
              <span *ngIf="detail.scommessa === '13'">
                <span *ngIf="detail.risultato === '1'">{{'RACE.UNDER' | translate}}</span>
                <span *ngIf="detail.risultato === '2'">{{'RACE.OVER' | translate}}</span>
              </span>
              <span *ngIf="detail.scommessa !== '12' && detail.scommessa !== '13'">
                {{detail.risultato}}
              </span>
            </strong>
          </span>
        </div>
        <div *ngIf="data.header.gioco !== 'QF'">
          <span class="text-center mb-1 w-100 ticket-result">
            {{'TICKETS.RESULT' | translate}}:
            <strong class="p-2 risultato">
              <span *ngIf="detail.risultato">{{detail.risultato}}</span>
            </strong>
          </span>
        </div>
        <div class="p-3 div-system-table">
          <table aria-hidden="true" class="table table-sm text-center mt-2" *ngIf="data.header.gioco === 'QF' && data.dettaglio[0].sistema">
          <thead>
          <tr>
            <th scope="col">
              {{'TICKETS.FIRST' | translate}}
              <span *ngIf="data.dettaglio[0].scommessa === '7' || data.dettaglio[0].scommessa === '9'"> - {{'TICKETS.SECOND' | translate}}</span>
              <span *ngIf="data.dettaglio[0].scommessa === '9'"> - {{'TICKETS.THIRD' | translate}}</span>
            </th>
            <th scope="col">
              <span *ngIf="data.dettaglio[0].scommessa === '7' || data.dettaglio[0].scommessa === '9'">{{'TICKETS.FIRST' | translate}} -</span>
              {{'TICKETS.SECOND' | translate}}
              <span *ngIf="data.dettaglio[0].scommessa === '9'"> - {{'TICKETS.THIRD' | translate}}</span>
            </th>
            <th scope="col" *ngIf="data.combinazioni && data.combinazioni[0].runner3">
              <span *ngIf="data.dettaglio[0].scommessa === '9'">{{'TICKETS.FIRST' | translate}} - {{'TICKETS.SECOND' | translate}} - </span>
              {{'TICKETS.THIRD' | translate}}
            </th>
            <th scope="col">{{'TICKETS.ODD' | translate}}</th>
            <th scope="col">{{'TICKETS.WINNING' | translate}}</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let combination of data.combinazioni">
            <tr class="bd-callout" [ngClass]="{'bd-callout-danger': combination.stato === '0',
            'bd-callout-success': combination.stato === '1',
            'bd-callout-info': combination.stato === '2',
            'bd-callout-warning': combination.stato === '3'}">
              <td>{{combination.pos1}}</td>
              <td>{{combination.pos2}}</td>
              <td *ngIf="combination.runner3">{{combination.pos3}}</td>

              <td>{{combination.quota/100 | number: '1.2-2'}}</td>
              <td>{{truncateDecimal((combination.quota/100) * (data.dettaglio[0].costo_unitario/100)) | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</td>
            </tr>
          </ng-container>
          </tbody>
        </table>
        </div>
        <div class="ticket-items-padding" *ngIf="(detail.riduzione && detail.riduzione.length > 0) && (detail.quota_rit && detail.quota_rit !== detail.quota)"
                [@.disabled]="disableAnimation">
          <mat-expansion-panel [expanded]="false" style="width: 100%">
            <mat-expansion-panel-header>
              <mat-panel-description>
                <div [ngClass]="{'reduction': detail.riduzione && detail.riduzione.length > 0}"><small>
                  <mat-icon>help_outline</mat-icon>{{'TICKETS.INFO_REDUCTION' | translate}}
                </small></div>
              </mat-panel-description>
            </mat-expansion-panel-header>
            <table aria-hidden="true" class="table table-sm div-100w">
              <thead>
              <th scope="col">#</th>
              <th scope="col">{{'RACE.HORSE' | translate}}</th>
              <th scope="col">{{'TICKETS.DATE_WITHDRAWAL' | translate}}</th>
              <th scope="col">{{'TICKETS.ODD' | translate}}</th>
              <th scope="col" class="text-right">{{'GENERAL.PERCENTAGE' | translate}}</th>
              </thead>
              <tbody>
              <tr *ngFor="let riduzione of detail.riduzione">
                <td width="10%">{{riduzione.esito}}</td>
                <td width="30%" matTooltip="{{riduzione.name}}" class="td-horse-reduction">{{riduzione.name}}</td>
                <td width="40%">
                  {{riduzione.data_ritiro + 'Z' | date : 'd/MM/yyyy, H:mm:ss':'':this.translateService.currentLang}}
                </td>
                <td width="10%">{{riduzione.quota/100 | number : '1.2-2'}}</td>
                <td width="10%" class="text-right">{{riduzione.percentuale/100}}%</td>
              </tr>
              </tbody>
            </table>
          </mat-expansion-panel>
        </div>
        </div>
      </div>
        <div class="quote-detail ticket-items-padding text-right mb-3">
          <div class="p-1" *ngIf="data.header.gioco === 'QF' && !(data.dettaglio[0].sistema)">
            <strong>{{'CART.TOTAL ODD' | translate}}:</strong>
            {{data.header.pagamento_massimo/data.header.puntata | number : '1.2-2'}}
          </div>
          <div class="p-1"><strong>{{'TICKETS.AMOUNT' | translate}}:</strong>
            {{data.header.puntata/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
          </div>

          <div class="p-1 text-danger" *ngIf="data.header.stato_spoglio === '0' && (data.header.pagamento_reale <= 0 || data.header.pagamento <= 0)">
            <strong>Non Vincente</strong>
          </div>
          <div class="p-1 text-warning" *ngIf="(data.header.stato_spoglio === '12' || data.header.stato_spoglio === '13') && data.header.rimborso > 0">
            <strong>Rimborso: </strong>&ensp;<span *ngIf="data.header.rimborso > 0">{{data.header.rimborso/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
          </div>
          <div class="p-1 text-success" *ngIf="data.header.pagamento_reale > 0 || data.header.pagamento > 0">
            <strong>{{'TICKETS.WINNING' | translate}}:</strong>
            <span *ngIf="data.header.pagamento_reale <= 0"> &#x02013; </span>
            <span *ngIf="data.header.pagamento_reale > 0">
            {{data.header.pagamento_reale/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
            <span *ngIf="data.header.pagamento <= 0"> &#x02013; </span>
            <span *ngIf="data.header.pagamento > 0">
            {{data.header.pagamento/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
          </div>
          <div class="p-1 text-success" *ngIf="data.header.pagamento_massimo"><strong>{{'CART.MAX WIN' | translate}}:</strong>
            {{data.header.pagamento_massimo/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="data.scommesse">
        <div *ngFor="let detail of data.scommesse" class="ticket-items">
          <div *ngIf="detail.fissa === '1'" class="sys-fissa">
            <span>FISSA</span>
          </div>
          <div>
            <div class="ml-1">
              <div *ngIf="detail.scommessa !== '13'" class="div-race-number">
                <div>{{'RACE.RACE' | translate}}</div>
                <div *ngIf="data.header.antepost === '1'">{{detail.descrizione}}</div>
                <div *ngIf="data.header.antepost === '1'">{{'MENU.ANTEPOST' | translate | uppercase}}</div>
                <div class="div-number-size" *ngIf="data.header.antepost === '0'">{{detail.number}}</div>
              </div>
              <div *ngIf="detail.scommessa === '13'" class="div-race-number">
                <div>Vittoria</div>
                <div class="div-number-size">U/O</div>
              </div>
            </div>
            <div class="ml-1 mr-1 div-tshirt" *ngIf="detail.image">
              <img #image class="img-tshirt" alt="image tshirt" [src]="this.imgUrl + detail.image"  (error)="image.hidden = true"
                   (load)="image.hidden = false" [hidden]="image.hidden">
            </div>
            <div class="p-1 div-tdescr">
              <div *ngIf="detail.scommessa !== '13'">
                <span *ngIf="detail.rdate" class="text-capitalize text-ellipsis"
                      title="{{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}} - {{detail.course}}">{{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}}
                  - {{detail.course}}
                </span>
              </div>
              <div *ngIf="detail.scommessa === '13'">
                <span *ngIf="detail.rdate" class="text-capitalize text-ellipsis"
                      title="{{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}} - {{detail.course}}">
                  {{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}}
                </span>
                <span>{{detail.course}}</span>
                <div *ngIf="detail.scommessa === '13'">
                  <small>{{'RACE.RACES' | translate}} ({{detail.extra2}})</small>
                </div>
              </div>

              <div class="mt-1" *ngIf="detail.info_agg_desc && detail.scommessa !== '13'">
                <span>{{detail.info_agg_desc}}</span>
              </div>
              <div class="mt-1" *ngIf="detail.scommessa === '13'">
                <span>{{'RACE.UNDER OVER' | translate}} {{'GENERAL.WINS' | translate}} {{(detail.info_agg | hexToDecimal)/100 | number : '1.2-2'}}</span>
              </div>
              <div class="mt-1" *ngIf="!detail.info_agg_desc && detail.scommessa !== '12'">
                <strong>{{'RACE.HORSE' | translate}}</strong>: &#x00023;{{detail.esito}} {{detail.cavallo}}
              </div>
              <div class="mt-1" *ngIf="!detail.info_agg_desc && detail.scommessa === '12'">
                <strong *ngIf="detail.esito === '1'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.EVEN' | translate}}</strong>
                <strong *ngIf="detail.esito === '2'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.ODD' | translate}}</strong>
              </div>
              <div class="mt-1" *ngIf="detail.scommessa !== '13'">
                <span class="mr-1"><strong>{{'TICKETS.BET' | translate}}:</strong>
                  {{('RACE.' + betType[detail.scommessa] | uppercase) | translate}}
                </span>
              </div>
              <div class="mt-1" *ngIf="detail.scommessa === '13'">
                <span class="mr-1"><strong>{{'TICKETS.BET' | translate}}:</strong>
                  {{('RACE.UNDER OVER') | translate}}
                </span>
              </div>
              <div class="mt-1" *ngIf="detail.info_agg_desc && detail.scommessa !== '13'">
                <strong>{{'RACE.OUTCOME' | translate}}</strong>: {{detail.esito}} ({{numberHorse(detail.info_agg,detail.esito)}} - {{detail.info_agg_desc.split(' VS ')[detail.esito-1]}})
              </div>
              <div class="mt-1" *ngIf="detail.info_agg_desc && detail.scommessa === '13'">
                <strong *ngIf="detail.esito === '1'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.UNDER' | translate}}</strong>
                <strong *ngIf="detail.esito === '2'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.OVER' | translate}}</strong>
              </div>
            </div>
            <div class="col-quota">
              <small class="mb-1">{{'TICKETS.ODD' | translate}}</small>
              <div>
                <strong class="p-2 quota" [ngClass]="{
                'text-danger': detail.stato === '0',
                'text-success': detail.stato === '1',
                '': detail.stato === '2',
                'text-warning': detail.stato === '3'}">
                  <span [ngClass]="{'quota_old' : detail.quota_rit && detail.quota_rit !== '0' && detail.quota_rit !== detail.quota}">{{detail.quota/100 | number : '1.2-2'}}</span>
                  <span *ngIf="detail.quota_rit !== '0' && detail.quota_rit !== detail.quota">{{detail.quota_rit/100 | number : '1.2-2'}}</span>
                </strong>
              </div>
            </div>
            <div class="col-risultato" *ngIf="detail.risultato && detail.risultato !== ''">
              <small class="mb-1">{{'TICKETS.RESULT' | translate}}</small>
              <div *ngIf="detail.scommessa !== '12'">
                <strong class="p-2 risultato">{{detail.risultato}}</strong>
              </div>
              <div *ngIf="detail.scommessa === '12'">
                <strong class="p-2 risultato" *ngIf="detail.risultato === '1'">{{'GENERAL.EVEN' | translate}}</strong>
                <strong class="p-2 risultato" *ngIf="detail.risultato === '2'">{{'GENERAL.ODD' | translate}}</strong>
              </div>
              <div *ngIf="detail.scommessa === '13'">
                <strong class="p-2 risultato" *ngIf="detail.risultato === '1'">{{'RACE.UNDER' | translate}}</strong>
                <strong class="p-2 risultato" *ngIf="detail.risultato === '2'">{{'RACE.OVER' | translate}}</strong>
              </div>
            </div>
          </div>
        </div>
        <div class="quote-detail ticket-items-padding text-right mb-3">
          <div class="p-1" *ngIf="data.header.gioco === 'QF'">
            <strong>{{'CART.TOTAL ODD' | translate}}:</strong>
            {{data.header.pagamento_massimo/data.header.puntata | number : '1.2-2'}}
          </div>
          <div class="p-1"><strong>{{'TICKETS.AMOUNT' | translate}}:</strong>
            {{data.header.puntata/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
          </div>

          <div class="p-1 text-danger" *ngIf="data.header.stato_spoglio === '0' && (data.header.pagamento_reale <= 0 || data.header.pagamento <= 0)">
            <strong>Non Vincente</strong>
          </div>
          <div class="p-1 text-warning" *ngIf="(data.header.stato_spoglio === '12' || data.header.stato_spoglio === '13') && data.header.rimborso > 0">
            <strong>Rimborso: </strong>&ensp;<span *ngIf="data.header.rimborso > 0">{{data.header.rimborso/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
          </div>
          <div class="p-1 text-success" *ngIf="data.header.pagamento_reale > 0 || data.header.pagamento > 0">
            <strong>{{'TICKETS.WINNING' | translate}}:</strong>
            <span *ngIf="data.header.pagamento_reale <= 0"> &#x02013; </span>
            <span *ngIf="data.header.pagamento_reale > 0">
            {{data.header.pagamento_reale/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
            <span *ngIf="data.header.pagamento <= 0"> &#x02013; </span>
            <span *ngIf="data.header.pagamento > 0">
            {{data.header.pagamento/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
          </div>
          <div class="p-1 text-success" *ngIf="data.header.pagamento_massimo"><strong>{{'CART.MAX WIN' | translate}}:</strong>
            {{data.header.pagamento_massimo/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
          </div>
        </div>
        <table aria-hidden="true" class="table table-sm text-center mt-2" *ngIf="data.header.gioco === 'QF'">
          <thead>
          <tr>
            <th scope="col">Sistema</th>
            <th scope="col">Importo Base</th>
            <th scope="col">Importo Complessivo</th>
            <th scope="col">Multiple</th>
            <th scope="col">Vincita Potenziale</th>
          </tr>
          </thead>
          <tbody>
          <ng-container *ngFor="let sistemi of data.sistemi">
            <tr>
              <td>
                <a (click)="btnCombination(data)" *ngIf="sistemi.codice_sistema < 4">{{'CART.SIS_' + sistemi.codice_sistema | translate}}</a>
                <span *ngIf="sistemi.codice_sistema > 3">{{sistemi.codice_sistema}}{{'CART.SIS_X' | translate}}</span>
              </td>
              <td>{{sistemi.importo_base / 100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</td>
              <td>{{sistemi.importo_complessivo / 100 |currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</td>
              <td>{{sistemi.num_multiple}}</td>
              <td>{{sistemi.vincita_potenziale / 100 |currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</td>
            </tr>
          </ng-container>
          </tbody>
        </table>
      </ng-container>
      <mat-expansion-panel [expanded]="false" class="ticket-items-padding">
        <mat-expansion-panel-header>
          <mat-panel-description>
            Informazioni biglietto
          </mat-panel-description>
        </mat-expansion-panel-header>
        <mat-grid-list cols="{{columInfoSisal()}}" rowHeight="20px" class="text-right">

            <mat-grid-tile><strong>ID:&ensp;</strong>{{data.header.id_biglietto}}</mat-grid-tile>
            <mat-grid-tile><strong>Stato:&ensp;</strong>{{('TICKETS.' + data.header.des_stato | uppercase)  | translate}}</mat-grid-tile>


            <mat-grid-tile>
              <strong>Conto:&ensp;</strong>{{data.header.codice_conto }}
            </mat-grid-tile>
            <mat-grid-tile>
                <strong>{{'TICKETS.CONCESSIONE' | translate}}:&ensp;</strong>
                <span *ngIf="!((_identifyObs$ | async).csmf_temp && (_identifyObs$ | async).csmf_temp !== '')">{{(_identifyObs$ | async).conc}}</span>
                <span *ngIf="(_identifyObs$ | async).csmf_temp && (_identifyObs$ | async).csmf_temp !== ''">{{(_identifyObs$ | async).csmf_temp}}</span>
            </mat-grid-tile>



            <mat-grid-tile>
              <strong>{{'TICKETS.DATE' | translate}}:&ensp;</strong>
              {{data.header.gioco !== 'QF' ? (data.header.data_ora_vendita | date : 'dd/MM/yyyy - H:mm:ss':'':translateService.currentLang) : (data.header.data_ora_vendita + 'Z' | date : 'dd/MM/yyyy - H:mm:ss':'':translateService.currentLang)}}
            </mat-grid-tile>
            <mat-grid-tile><strong>{{'TICKETS.EXPIRIT DATE' | translate}}:&ensp;</strong>
              {{data.header.data_competenza | date : 'dd/MM/yyyy':'':this.translateService.currentLang}}
            </mat-grid-tile>


            <mat-grid-tile><strong>{{'TICKETS.TYPE GAME' | translate}}:&ensp;</strong><span *ngIf="data.header.gioco === 'QF'">{{'GENERAL.FIXED_QUOTE' | translate}}</span><span *ngIf="data.header.antepost && data.header.antepost === '1'">&ensp;ANTEPOST</span> <span *ngIf="data.header.gioco === 'TOT'">{{'GENERAL.TOTE' | translate}}</span> <span *ngIf="data.header.gioco === 'PSR'">{{'GENERAL.PSR' | translate}}</span></mat-grid-tile>
            <mat-grid-tile><strong>{{'TICKETS.NUMBER EVENT' | translate}}:&ensp;</strong>{{data.header.num_scommesse}}</mat-grid-tile>

            <mat-grid-tile *ngIf="data.header.accept === '1'"><strong>{{'TICKETS.CHANGEQUOTE' | translate}}</strong></mat-grid-tile>
        </mat-grid-list>
      </mat-expansion-panel>
    </div>
    <div class="ticket-details-bottom p-1"></div>
  </div>
  <ng-template #defalut>
    <div class="ticket-details-top pl-2 pt-3 pb-3 pr-2">
      <span *ngIf="data.header.gioco !== 'QF'" matBadge="T"
        class="tot-circle pr-2"><strong>{{'TICKETS.TICKET' | translate}}:</strong>
        {{data.header.id_biglietto}}</span>
      <span *ngIf="data.header.gioco === 'QF'"><strong>{{'TICKETS.TICKET' | translate}}:</strong>
        {{data.header.id_biglietto}}</span>
      <span *ngIf="data.header.bonus === '3' || data.header.bonus === '4'" matBadge="{{'CART.FB' | translate}}"
            matTooltip="{{'CART.FREEBET' | translate}}"
            matBadgeOverlap="false">
      </span>
      <mat-icon (click)="this.dialogWindow.closeAll()" class="ticket-details-close-button" *ngIf="isDialog">close
      </mat-icon>
    </div>

    <ng-container *ngIf="combinationSistemi.length === 0">
      <div class="ticket-inner-top p-1" [ngClass]="{
          'ticket-bg-danger': data.header.stato_spoglio === '0' || data.header.stato_spoglio === '110',
          'ticket-bg-success': data.header.stato_spoglio === '1' || data.header.stato_spoglio === '11',
          'ticket-bg-info': data.header.stato_spoglio === '2',
          'ticket-bg-warning': data.header.stato_spoglio === '3' || data.header.stato_spoglio === '13'}">
        <div>
          <div class="p-1">{{('TICKETS.' + data.header.des_stato | uppercase)  | translate}}</div>
          <div class="p-1"><strong>{{'TICKETS.TYPE GAME' | translate}}:</strong> {{data.header.gioco}} <span *ngIf="data.header.antepost && data.header.antepost === '1'">{{'MENU.ANTEPOST' | translate | uppercase}}</span></div>
        </div>
        <div>
          <!-- <div class="p-2"><strong>Type Game:</strong> {{data.header.gioco}}</div> -->
          <div class="p-1"><strong>{{'TICKETS.NUMBER EVENT' | translate}}:</strong> {{data.header.num_scommesse}}</div>
          <div class="p-1">
            <strong>{{'TICKETS.WINNING' | translate}}:</strong>
            <span *ngIf="data.header.pagamento_reale <= 0"> &#x02013; </span>
            <span *ngIf="data.header.pagamento_reale > 0">
            {{data.header.pagamento_reale/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
            <span *ngIf="data.header.pagamento <= 0"> &#x02013; </span>
            <span *ngIf="data.header.pagamento > 0">
            {{data.header.pagamento/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
          </div>
        </div>
        <div>
          <div class="p-1"><strong>{{'TICKETS.DATE' | translate}}:</strong>
            {{data.header.gioco !== 'QF' ? (data.header.data_ora_vendita | date : 'd MMM yyyy H:mm:ss':'':translateService.currentLang) : (data.header.data_ora_vendita + 'Z' | date : 'd MMM yyyy H:mm:ss':'':translateService.currentLang)}}
          </div>
          <div class="p-1"><strong>{{'TICKETS.AMOUNT' | translate}}:</strong>
            {{data.header.puntata/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
          </div>
        </div>
        <div>
          <div class="p-1"><strong>{{'TICKETS.EXPIRIT DATE' | translate}}:</strong>
            {{data.header.data_competenza | date : 'd MMM yyyy':'':this.translateService.currentLang}}</div>
          <div class="p-1" *ngIf="data.header.pagamento_massimo"><strong>{{'CART.MAX WIN' | translate}}:</strong>
            {{data.header.pagamento_massimo/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
          </div>
        </div>
        <div>
          <div class="p-1">
            <strong>{{'TICKETS.CHANGEQUOTE' | translate}}:&ensp;</strong>
            <span *ngIf="data.header.accept === '1'">Yes</span>
            <span *ngIf="data.header.accept === '0'">No</span>
          </div>
        </div>
        <div *ngIf="data.dettaglio && data.dettaglio.length > 1">
          <div class="p-1"></div>
          <div class="p-1"><strong>{{'CART.TOTAL ODD' | translate}}:</strong>
            {{data.header.pagamento_massimo/data.header.puntata | number : '1.2-2'}}
          </div>
        </div>
      </div>
      <div class="p-1 pt-2 pb-2 ticket-details-content">
        <!--<div class="p-2" *ngIf="data.header.pagamento_reale !== '0'"><strong>Winning:</strong> {{data.header.pagamento_reale/100 | number : '1.2-2'}}
          {{data.header.currency}}
        </div>-->

        <div class="ticket-items" *ngIf="data.header.descrizione">
          <div>
            <div class="ml-1">
              <div class="div-race-number">
                <div>{{'RACE.RACE' | translate}}</div>
                <div class="div-number-size">{{data.header.race}}</div>
              </div>
            </div>

            <div class="p-1 mw-100 flex-grow-1">
              <div>
              <span class="mr-1"><strong>Pal:</strong> {{data.header.palinsesto}} <span *ngIf="data.header.avvenimento"><strong>Avv:</strong>
                {{data.header.avvenimento}}</span><span *ngIf="data.header.concorso"><strong>Conc:</strong>
                {{data.header.concorso}}</span></span>
              </div>
              <div class="mt-1">
              <span class="text-capitalize text-ellipsis"
                    title="{{data.header.descrizione}}">{{data.header.descrizione}}</span>
              </div>
              <div class="mt-1">
              <span class="text-capitalize text-ellipsis"
                    title="{{data.header.gioco !== 'QF' ? (data.header.data_avvenimento | date : 'd MMM yyyy H:mm':'':translateService.currentLang) : (data.header.data_avvenimento + 'Z' | date : 'd MMM yyyy H:mm':'':translateService.currentLang)}}">
                {{data.header.gioco !== 'QF' ? (data.header.data_avvenimento | date : 'd MMM yyyy H:mm':'':translateService.currentLang) : (data.header.data_avvenimento + 'Z' | date : 'd MMM yyyy H:mm':'':translateService.currentLang)}}
              </span>
              </div>
            </div>

            <div class="text-center" *ngIf="data.dettaglio[0].risultato && data.dettaglio[0].risultato !== ''">
              <small class="mb-1">{{'TICKETS.RESULT' | translate}}</small>
              <div>
                <strong class="p-2 risultato">{{data.dettaglio[0].risultato}}</strong>
              </div>
            </div>
          </div>
        </div>
        <ng-container *ngIf="data.dettaglio">
          <div *ngFor="let detail of data.dettaglio" class="ticket-items">
            <div *ngIf="data.header.gioco === 'QF'">
              <div class="ml-1">
                <div *ngIf="detail.scommessa !== '13'" class="div-race-number">
                  <div>{{'RACE.RACE' | translate}}</div>
                  <div *ngIf="data.header.antepost === '1'">{{detail.descrizione}}</div>
                  <div *ngIf="data.header.antepost === '1'">{{'MENU.ANTEPOST' | translate | uppercase}}</div>
                  <div class="div-number-size" *ngIf="data.header.antepost === '0'">{{detail.descrizione | numberrace:'num'}}</div>
                </div>
                <div *ngIf="detail.scommessa === '13'" class="div-race-number">
                  <div>Vittoria</div>
                  <div class="div-number-size">U/O</div>
                </div>
              </div>
              <div class="ml-1 mr-1 div-tshirt">
                <img #image class="img-tshirt" alt="image tshirt" [src]="this.imgUrl + detail.image" (error)="image.hidden = true"
                     (load)="image.hidden = false" [hidden]="image.hidden">
              </div>
              <div class="p-1 div-tdescr">
                <div *ngIf="detail.scommessa !== '13'">
                    <span *ngIf="detail.rdate" class="text-capitalize text-ellipsis" title="{{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}} - {{detail.descrizione | numberrace:'desc'}}">
                        {{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}}
                        <br/>
                        {{detail.descrizione | numberrace:'desc'}}
                    </span>
                </div>
                <div *ngIf="detail.scommessa === '13'">
                    <span *ngIf="detail.rdate" class="text-capitalize text-ellipsis" title="{{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}} - {{detail.descrizione | numberrace:'desc'}}">
                      {{detail.rdate + 'Z' | date : 'd MMM yyyy H:mm':'':this.translateService.currentLang}}
                    </span>
                    <span>{{detail.descrizione | numberrace:'desc'}}</span>
                      <div *ngIf="detail.scommessa === '13'">
                        <small>{{'RACE.RACES' | translate}} ({{detail.extra2}})</small>
                      </div>
                </div>

                <div class="mt-1" *ngIf="detail.info_agg_desc && detail.scommessa !== '13' && excludeViewEsito(detail.scommessa)">
                  <span>{{detail.info_agg_desc}}</span>
                </div>
                <div class="mt-1" *ngIf="detail.info_agg_desc && (detail.scommessa === '14' || detail.scommessa === '16' || detail.scommessa === '18' || detail.scommessa === '22' || detail.scommessa === '23' || detail.scommessa === '24')">
                    <span>
<!--                        {{'RACE.HORSE' | translate}}: #{{detail.info_agg | infoAggBet: detail.scommessa: true}}-->
                        <span *ngIf="detail.scommessa !== '16' && detail.scommessa !== '18'">{{detail.info_agg_desc}}</span>
                        <span *ngIf="detail.scommessa === '22' || detail.scommessa === '23' || detail.scommessa === '24'"> {{'RACE.NOTPLACE_INFO' | translate }}</span>
                        <span *ngIf="detail.scommessa === '16' || detail.scommessa === '18'">{{detail.info_agg_desc.split('-')[0]}} {{('RACE.' + betType[detail.scommessa] + 'info_agg' | uppercase) | translate: {lenghts: detail.info_agg | infoAggBet: detail.scommessa, dispersion: detail.info_agg | infoAggBet: detail.scommessa} }}</span>
                    </span>
                </div>

                <div class="mt-1" *ngIf="detail.scommessa === '13'">
                  <span>{{'RACE.UNDER OVER' | translate}} {{'GENERAL.WINS' | translate}} {{(detail.info_agg | hexToDecimal)/100 | number : '1.2-2'}}</span>
                </div>
                <div class="mt-1" *ngIf="!(data.dettaglio[0].sistema) && !detail.info_agg_desc && detail.scommessa !== '12'">
                  <strong *ngIf="data.dettaglio[0].tipologia !== 'GH'">{{'RACE.HORSE' | translate}}</strong>
                  <strong *ngIf="data.dettaglio[0].tipologia === 'GH'">{{'RACE.HORSE' | translate}}</strong>: &#x00023;{{detail.esito}} {{detail.cavallo}}
                </div>
                <div class="mt-1" *ngIf="!(data.dettaglio[0].sistema) && !detail.info_agg_desc && detail.scommessa === '12'">
                  <strong *ngIf="detail.esito === '1'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.EVEN' | translate}}</strong>
                  <strong *ngIf="detail.esito === '2'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.ODD' | translate}}</strong>
                </div>
                <div class="mt-1" *ngIf="detail.scommessa !== '13'">
                    <span class="mr-1"><strong>{{'TICKETS.BET' | translate}}:</strong>
                      {{('RACE.' + betType[detail.scommessa] | uppercase) | translate}}
                    </span>
                </div>
                <div class="mt-1" *ngIf="detail.scommessa === '13'">
                <span class="mr-1"><strong>{{'TICKETS.BET' | translate}}:</strong>
                  {{('RACE.UNDER OVER') | translate}}
                </span>
                </div>
                <div class="mt-1" *ngIf="!(data.dettaglio[0].sistema) && detail.info_agg_desc && detail.scommessa !== '13' && excludeViewEsito(detail.scommessa)">
                  <strong *ngIf="data.dettaglio[0].tipologia !== 'GH'">{{'RACE.OUTCOME' | translate}}</strong>
                  <strong *ngIf="data.dettaglio[0].tipologia === 'GH'">{{'RACE.OUTCOME' | translate}}</strong>: {{detail.esito}} ({{numberHorse(detail.info_agg,detail.esito)}} - {{detail.info_agg_desc.split(' VS ')[detail.esito-1]}})
                </div>
                <div class="mt-1" *ngIf="!(data.dettaglio[0].sistema) && detail.info_agg_desc && detail.scommessa === '13'">
                  <strong *ngIf="detail.esito === '1'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.UNDER' | translate}}</strong>
                  <strong *ngIf="detail.esito === '2'">{{'RACE.OUTCOME' | translate}}: {{'GENERAL.OVER' | translate}}</strong>
                </div>
                <div *ngIf="(data.dettaglio[0].sistema)">
                  <strong>{{'CART.PERCOMBO' | translate}}: </strong>
                  <span>{{detail.costo_unitario/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</span>
                </div>
              </div>
              <div class="col-quota" *ngIf="!(data.dettaglio[0].sistema)">
                <small class="mb-1">{{'TICKETS.ODD' | translate}}</small>
                <div>
                  <strong class="p-2 quota" [ngClass]="{
                'text-danger': detail.stato === '0',
                'text-success': detail.stato === '1',
                '': detail.stato === '2',
                'text-warning': detail.stato === '3'}">
                  <span [ngClass]="{'quota_old' : detail.quota_rit && detail.quota_rit !== '0' && detail.quota_rit !== detail.quota}">{{detail.quota/100 | number : '1.2-2'}}</span>
                    <span *ngIf="detail.quota_rit && detail.quota_rit !== detail.quota">{{detail.quota_rit/100 | number : '1.2-2'}}</span>
                  </strong>
                </div>
              </div>
              <div class="col-risultato" *ngIf="detail.risultato && detail.risultato !== ''">
                <small class="mb-1">{{'TICKETS.RESULT' | translate}}</small>
                <div *ngIf="detail.scommessa !== '12' && excludeViewEsito(detail.scommessa)">
                  <strong class="p-2 risultato">{{detail.risultato}}</strong>
                </div>
                  <div *ngIf="(detail.scommessa === '22' || detail.scommessa === '23' || detail.scommessa === '24')">
                      <strong class="p-2 risultato">{{detail.risultato}}</strong>
                  </div>
                <div *ngIf="detail.scommessa === '12'">
                  <strong class="p-2 risultato" *ngIf="detail.risultato === '1'">{{'GENERAL.EVEN' | translate}}</strong>
                  <strong class="p-2 risultato" *ngIf="detail.risultato === '2'">{{'GENERAL.ODD' | translate}}</strong>
                </div>
                <div *ngIf="detail.scommessa === '13'">
                  <strong class="p-2 risultato" *ngIf="detail.risultato === '1'">{{'RACE.UNDER' | translate}}</strong>
                  <strong class="p-2 risultato" *ngIf="detail.risultato === '2'">{{'RACE.OVER' | translate}}</strong>
                </div>
                <div *ngIf="(detail.scommessa === '14' || detail.scommessa === '16' || detail.scommessa === '18')">
                  <strong class="p-2 risultato" *ngIf="detail.risultato === '1'">{{'RACE.WINNER' | translate}}</strong>
                  <strong class="p-2 risultato" *ngIf="detail.risultato === '2'">{{'TICKETS.LOSER' | translate}}</strong>
                </div>
              </div>
            </div>
            <div *ngIf="(detail.riduzione && detail.riduzione.length > 0) && (detail.quota_rit && detail.quota_rit !== detail.quota)"
                    [@.disabled]="disableAnimation">
              <mat-expansion-panel [expanded]="false">
                <mat-expansion-panel-header>
                  <mat-panel-description>
                    <div [ngClass]="{'reduction': detail.riduzione && detail.riduzione.length > 0}"><small>
                      <mat-icon>help_outline</mat-icon>{{'TICKETS.INFO_REDUCTION' | translate}}
                    </small></div>
                  </mat-panel-description>
                </mat-expansion-panel-header>
                <table class="table table-sm div-100w" aria-hidden="true">
                  <thead>
                  <th scope="col">#</th>
                  <th scope="col">{{'RACE.HORSE' | translate}}</th>
                  <th scope="col">{{'TICKETS.DATE_WITHDRAWAL' | translate}}</th>
                  <th scope="col">{{'TICKETS.ODD' | translate}}</th>
                  <th scope="col" class="text-right">{{'GENERAL.PERCENTAGE' | translate}}</th>
                  </thead>
                  <tbody>
                  <tr *ngFor="let riduzione of detail.riduzione">
                    <td width="10%">{{riduzione.esito}}</td>
                    <td width="30%" matTooltip="{{riduzione.name}}" class="td-horse-reduction">{{riduzione.name}}</td>
                    <td width="40%">
                      {{riduzione.data_ritiro + 'Z' | date : 'd/MM/yyyy, H:mm:ss':'':this.translateService.currentLang}}
                    </td>
                    <td width="10%">{{riduzione.quota/100 | number : '1.2-2'}}</td>
                    <td width="10%" class="text-right">{{riduzione.percentuale/100}}%</td>
                  </tr>
                  </tbody>
                </table>
              </mat-expansion-panel>
            </div>
            <div *ngIf="data.header.gioco !== 'QF'" class="p-1 d-flex">
              <div class="flex-grow-1 mw-100">
                {{detail.des_scommessa}} {{'TOTESYSTEM.WITH_SYSTEM' | translate}} {{detail.sigla_sys}} ({{detail.map}})
              </div>
              <div>
                {{detail.importo/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
              </div>
            </div>
          </div>
          <table aria-hidden="true" class="table table-sm text-center mt-2" *ngIf="data.header.gioco === 'QF' && data.dettaglio[0].sistema">
            <thead>
            <tr>
              <th scope="col">
                {{'TICKETS.FIRST' | translate}}
                <span *ngIf="data.dettaglio[0].scommessa === '7' || data.dettaglio[0].scommessa === '9'"> - {{'TICKETS.SECOND' | translate}}</span>
                <span *ngIf="data.dettaglio[0].scommessa === '9'"> - {{'TICKETS.THIRD' | translate}}</span>
              </th>
              <th scope="col">
                <span *ngIf="data.dettaglio[0].scommessa === '7' || data.dettaglio[0].scommessa === '9'">{{'TICKETS.FIRST' | translate}} -</span>
                {{'TICKETS.SECOND' | translate}}
                <span *ngIf="data.dettaglio[0].scommessa === '9'"> - {{'TICKETS.THIRD' | translate}}</span>
              </th>
              <th scope="col" *ngIf="data.combinazioni && data.combinazioni[0].runner3">
                <span *ngIf="data.dettaglio[0].scommessa === '9'">{{'TICKETS.FIRST' | translate}} - {{'TICKETS.SECOND' | translate}} - </span>
                {{'TICKETS.THIRD' | translate}}
              </th>
              <th scope="col">{{'TICKETS.WINNING' | translate}}</th>
              <th *ngIf="environment.staging" scope="col">{{'TICKETS.STATUS' | translate}}</th>
            </tr>
            </thead>
            <tbody>
            <ng-container *ngFor="let combination of data.combinazioni">
              <tr class="bd-callout" [ngClass]="{'bd-callout-danger': combination.stato === '0',
            'bd-callout-success': combination.stato === '1',
            'bd-callout-info': combination.stato === '2',
            'bd-callout-warning': combination.stato === '3'}">
                <td>{{combination.pos1}}</td>
                <td>{{combination.pos2}}</td>
                <td *ngIf="combination.runner3">{{combination.pos3}}</td>
                <td *ngIf="!environment.staging">{{truncateDecimal((combination.quota/100) * (data.dettaglio[0].costo_unitario/100)) | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</td>
                <td class="comb-win" *ngIf="environment.staging" [ngClass]="{'text-decoration-line-through': combination.stato === '0'}">{{truncateDecimal((combination.quota/100) * (data.dettaglio[0].costo_unitario/100)) | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</td>
                <td class="comb-status" *ngIf="environment.staging">
                  <span *ngIf="combination.stato === '0'">{{'TICKETS.LOSER' | translate}}</span>
                  <span *ngIf="combination.stato === '1'">{{'TICKETS.WINNER' | translate}}</span>
                  <span *ngIf="combination.stato === '2'">{{'TICKETS.OPEN' | translate}}</span>
                  <span *ngIf="combination.stato === '3'">{{'TICKETS.OPEN' | translate}}</span>
                </td>
              </tr>
            </ng-container>
            </tbody>
          </table>
        </ng-container>
        <ng-container *ngTemplateOutlet="sistemi; context: {data: data, header: data.header}" ></ng-container>
      </div>
    </ng-container>

    <table aria-hidden="true" class="table table-sm text-center mt-2" *ngIf="data.header.gioco === 'QF' && data.sistemi">
      <thead>
      <tr>
        <th scope="col">Sistema</th>
        <th scope="col">Importo Base</th>
        <th scope="col">Importo Complessivo</th>
        <th scope="col">Multiple</th>
        <th scope="col">Vincita Potenziale</th>
      </tr>
      </thead>
      <tbody>
      <ng-container *ngFor="let sistemi of data.sistemi">
        <tr>
          <td>
            <span class="btn-link" style="cursor: pointer;" (click)="btnCombination(data, sistemi.codice_sistema)" *ngIf="sistemi.codice_sistema < 4">{{'CART.SIS_' + sistemi.codice_sistema | translate}}</span>
            <span class="btn-link" style="cursor: pointer;" (click)="btnCombination(data, sistemi.codice_sistema)" *ngIf="sistemi.codice_sistema > 3">{{sistemi.codice_sistema}}{{'CART.SIS_X' | translate}}</span>
          </td>
          <td>{{sistemi.importo_base / 100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</td>
          <td>{{sistemi.importo_complessivo / 100 |currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</td>
          <td>{{sistemi.num_multiple}}</td>
          <td>{{sistemi.vincita_potenziale / 100 |currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}</td>
        </tr>
      </ng-container>
      </tbody>
    </table>

    <ng-container *ngIf="combinationSistemi.length > 0">
        <div (click)="closeCombination()" class="p-2 bg-secondary d-flex justify-content-center align-items-center" style="cursor: pointer;"> <mat-icon>keyboard_arrow_left</mat-icon> INDIETRO</div>
        <div class="p-1 pt-2 pb-2 bg-secondary">
          <ngu-carousel [inputs]="carouselConfig" [dataSource]="combinationSistemi">
            <button mat-mini-fab NguCarouselPrev *ngIf="combinationSistemi.length > 1" class="prev mat-arrow" style="top: 15px;" tabindex="-1">
              <mat-icon>keyboard_arrow_left</mat-icon>
            </button>
            <div class="item" *nguCarouselDef="let comb, let i = index;">
              <div class="ticket-inner-top p-1 pl-5 pr-5" [ngClass]="{
                'ticket-bg-danger': combinationSistemi[i].stato === '0' || combinationSistemi[i].stato === '110',
                'ticket-bg-success': combinationSistemi[i].stato === '1' || combinationSistemi[i].stato === '11',
                'ticket-bg-info': combinationSistemi[i].stato === '2',
                'ticket-bg-warning': combinationSistemi[i].stato === '3' || combinationSistemi[i].stato === '13'}">

                <div class="align-items-center">
                  <div>
                    <div class="p-1">
                      <strong>{{'TICKETS.AMOUNT' | translate}}:</strong>
                      {{combinationSistemi[i].prezzo/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
                    </div>
                    <div class="p-1">
                      <strong>{{'TICKETS.WINNING' | translate}}:</strong>
                      {{combinationSistemi[i].vincita/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
                    </div>
                    <div class="p-1">
                      <strong>{{'CART.MAX WIN' | translate}}:</strong>
                      {{combinationSistemi[i].vincita_potenziale/100 | currency:data.header.currency:'symbol':'1.2-2':this.translateService.currentLang}}
                    </div>
                  </div>
                  <div>
                    <span>{{i + 1}} / {{combinationSistemi.length}}</span>
                  </div>
                </div>
              </div>
              <div class="ticket-details-content">
                <ng-container *ngTemplateOutlet="sistemi; context: {data: comb, header: data.header}" ></ng-container>
              </div>
            </div>
            <button mat-mini-fab NguCarouselNext *ngIf="combinationSistemi.length > 1" class="next mat-arrow" style="top: 15px;" tabindex="-1">
              <mat-icon>keyboard_arrow_right</mat-icon>
            </button>
          </ngu-carousel>
        </div>
    </ng-container>

    <div class="ticket-details-bottom p-1">
      <div class="d-flex justify-content-between">
        <!-- <div class="p-2"><strong>Type Game:</strong> {{data.header.gioco}}</div> -->
        <div class="p-1">
            <strong>{{'TICKETS.CONCESSIONE' | translate}}</strong>
            <span *ngIf="!((_identifyObs$ | async).csmf_temp && (_identifyObs$ | async).csmf_temp !== '')">{{(_identifyObs$ | async).conc}}</span>
            <span *ngIf="((_identifyObs$ | async).csmf_temp && (_identifyObs$ | async).csmf_temp !== '')">{{(_identifyObs$ | async).csmf_temp}}</span>
        </div>
        <div class="pl-1 pt-1 pb-1"><strong>{{'TICKETS.CODICE CONTO' | translate}}</strong>
          {{data.header.codice_conto }}
        </div>
      </div>
      <mat-chip-list class="p-1">
        <mat-chip color="accent" class="ticket-bg-danger" disableRipple selected>{{'TICKETS.LOSER' | translate}}
        </mat-chip>

        <mat-chip color="accent" class="ticket-bg-success" disableRipple selected>{{'TICKETS.WINNER' | translate}}
        </mat-chip>

        <mat-chip color="accent" class="ticket-bg-info" disableRipple selected>{{'TICKETS.OPEN' | translate}}</mat-chip>

        <mat-chip color="accent" class="ticket-bg-warning" disableRipple selected>{{'TICKETS.REFUNDABLE' | translate}}
        </mat-chip>
      </mat-chip-list>
    </div>
  </ng-template>
</div>

<app-page-error *ngIf="error" [error] = error></app-page-error>
